import React from "react";
import { ErrorMessage } from "../../../../designSystem/Message";
import { Button } from "../../../../designSystem/button/Button";
import { ButtonRow } from "../../../../designSystem/button/ButtonRow";
import { TextField } from "../../../../designSystem/formField/text/TextField";
import { Flex } from "../../../../designSystem/compositeComponents/FlexHelpers";
import { ActivityParticipantData, rng } from "../../../../amorg-common";
import { fieldValidation } from "../../../../amorg-common";
import { updateActivityParticipants } from "../../../../api/activityClientApi";

type AddExternalParticipantPanelProps = { 
    activityId: string,
    participants:ActivityParticipantData[],
    onAdded: ()=>void,
    onCancel:()=>void 
}
export function AddExternalParticipantPanel(props: AddExternalParticipantPanelProps): JSX.Element {
    const [submitState, setSubmitState] = React.useState<'pending'|'success'|'error'>('pending');
    const [inputState, setInputState] = React.useState({        
        name:'', 
        role: '', 
        email: '' 
    });
    async function handleClickAdd() {
        const result = await updateActivityParticipants(
            props.activityId,
            [
                ...props.participants,
                {
                    id: rng.getRandomId(),
                    type: { value: 'external' },
                    name: inputState.name,
                    role: inputState.role,
                    email: inputState.email
                }
            ]
        );
        if (result.errorMessage)
            setSubmitState('error');
        else {
            setSubmitState('success');
            props.onAdded();
        }
    }

    return (
        <div>
            <Flex flexDirection="column" gap={5}>
                <ErrorMessage show={submitState==='error'}>
                    En fejl opstod under oprettelsen. Prøv igen.
                </ErrorMessage>

                <Flex flexDirection="column" gap={16}>
                    <TextField
                        label="Navn"
                        value={inputState.name}
                        onChange={(newValue) => {
                            setInputState({ ...inputState, name: newValue })
                        }}
                        validator={(currentValue) => {
                            if((submitState==='pending' && currentValue === '') ||
                                fieldValidation.externalActivityParticipant.name(currentValue))
                                return { valid:true };
                            return { valid:false, errorMessage:`Ugyldigt navn. Skal udfyldes med maks. 100 (${currentValue.length}) tegn` };
                        }} />

                    <TextField
                        label="Email"
                        value={inputState.email}
                        onChange={(newValue) => {
                            setInputState({ ...inputState, email:newValue })
                        }}
                        validator={(currentValue) => {
                            if((submitState==='pending' && currentValue === '') ||
                                fieldValidation.externalActivityParticipant.email(currentValue))
                                return { valid:true };
                            return { valid:false, errorMessage:`Ugyldig e-mail addresse.` };
                        }} />

                    <TextField
                        label="Rolle"
                        value={inputState.role}
                        onChange={(newValue) => {
                            setInputState({ ...inputState, role:newValue })
                        }}
                        validator={(currentValue) => {
                            if((submitState==='pending' && currentValue === '') ||
                                fieldValidation.externalActivityParticipant.role(currentValue))
                                return { valid:true };
                            return { valid:false, errorMessage:`Ugyldig rolle. Skal udfyldes med maks. 100 (${currentValue.length}) tegn` };
                        }} />
                </Flex>
                <ButtonRow variant="right-aligned">
                    <Button
                        variant="text"
                        onClick={() => props.onCancel()}
                        text={"Annuller"} />

                    <Button
                        variant="filled"
                        onClick={handleClickAdd}
                        text={"Opret"} />
                </ButtonRow>
            </Flex>
        </div>
    );
}